import Popover from './Popover';
import PopoverTrigger from './PopoverTrigger';

Popover.PopoverTrigger = PopoverTrigger;

export default Popover;
